import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b58f022"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "buttons d-flex flex-row align-items-center justify-content-end",
  style: {"position":"absolute","right":"20px","z-index":"1","top":"0px"}
}
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus" }, null, -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash-alt" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_object_config_component = _resolveComponent("object-config-component")!

  return (_ctx.ready)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["config-group p-2 border-1", { border: _ctx.field.params?.layout === 'vertical' }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["content", _ctx.layoutClasses]),
          style: {"position":"relative"}
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.params?.template, (template, templateName) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "btn btn-sm btn-transparent",
                key: templateName,
                title: template.label ?? templateName,
                onClick: ($event: any) => (_ctx.addTemplate(templateName))
              }, [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(template.label ?? templateName), 1)
              ], 8, _hoisted_2))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.fieldOrder, (fieldName, fieldIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "component-wrap",
              key: fieldIdx,
              style: {"position":"relative"}
            }, [
              (_ctx.isRemovable(fieldName))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["buttons d-flex flex-row justify-content-end", {
                        'align-items-center': _ctx.field.children[fieldName].type !== 'group',
                        'align-items-start': _ctx.field.children[fieldName].type === 'group',
                    }]),
                    style: {"position":"absolute","right":"0px","z-index":"1","top":"8px","bottom":"8px"}
                  }, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-transparent",
                      onClick: ($event: any) => (_ctx.removeRow(fieldIdx))
                    }, _hoisted_6, 8, _hoisted_4)
                  ], 2))
                : _createCommentVNode("", true),
              _createVNode(_component_object_config_component, {
                field: _ctx.field.children[fieldName],
                fieldName: fieldName,
                value: _ctx.modelValue.childValues[fieldName],
                "wrap-using-row": false,
                "in-row": _ctx.field.params?.layout === 'horizontal',
                object: _ctx.object,
                onDependencyChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dependency-change', $event)))
              }, null, 8, ["field", "fieldName", "value", "in-row", "object"])
            ]))
          }), 128))
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}